import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import useCloseByKey from '@/hooks/useCloseByKey';

import PopupBackground from '../PopupBackground/PopupBackground';

import styles from './styles.module.scss';

interface PopupLayoutProps {
  closeHandler: () => void,
  isOpen: boolean,
}

const PopupLayout: FC<PropsWithChildren<PopupLayoutProps>> = ({
  children,
  closeHandler,
  isOpen,
}) => {
  useCloseByKey(closeHandler);

  return (
    <PopupBackground
      closeHandler={closeHandler}
      isOpen={isOpen}
    >
      <div className={styles.layout}>
        <span className={styles.cross} onClick={closeHandler}>
          <span />
          <span />
        </span>
        {children}
      </div>
    </PopupBackground>
  );
};

export default PopupLayout;
